// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3K448","title":"InfoRow_title__4eaZx"};